import React, { useEffect, useState, useCallback } from 'react';
import unsplash from '../api/unsplash';

import {
    DataGridPro,
    itIT,
    GridToolbarContainer,
    GridToolbarQuickFilter,
} from '@mui/x-data-grid-pro';
import { CustomFooterPersonalized } from '../utils/CustomFooterPersonalized';
import GlobalSnackbar from './Snackbar';
import 'moment/locale/it';

import { Edit } from '@mui/icons-material';
import {
    LinearProgress,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    TextField,
    DialogActions,
    Box,
    Card,
    CardContent,
    Zoom,
    CardHeader,
    IconButton,
} from '@mui/material';
import PropTypes from 'prop-types';
import DettaglioCategoria from './DettaglioCategoria';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const CategorieCorsi = ({ clientId }) => {
    const value = 0;
    const [categorie, setCategorie] = React.useState([]);

    const [openSnack, setOpenSnack] = useState(false);
    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };
    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    });
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [selectedCategoria, setSelectedCategoria] = useState(null);
    const [editForm, setEditForm] = useState({
        nome: '',
        tipo: '',
        codice: '',
    });

    const fetchData = useCallback(async () => {
        try {
            let endpoint = 'categorieCorsi';
            if (clientId) {
                endpoint = `categorieCorsi/${clientId}`;
            }
            const categorieCorsi = await unsplash.get(endpoint, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
            });
            setCategorie(categorieCorsi.data.data);
        } catch (error) {
            console.error(error.message);
        }
    }, [clientId]);

    useEffect(() => {
        fetchData();
    }, [clientId, fetchData]);

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <GridToolbarQuickFilter placeholder="Cerca..." />
                </Grid>
            </GridToolbarContainer>
        );
    }

    const baseColumns = [
        {
            field: 'id',
            headerName: 'ID Categoria',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            hide: true,
        },
        {
            field: 'nome',
            headerName: 'Nome Categoria',
            flex: 1,
            minWidth: 200,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            headerName: 'Tipo',
            field: 'tipo',
            flex: 1,
            minWidth: 200,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            headerName: 'Codice',
            field: 'codice',
            flex: 1,
            minWidth: 200,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
    ];

    const clientColumns = [
        {
            field: 'cliente',
            headerName: 'Cliente',
            flex: 1,
            minWidth: 200,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'corso',
            headerName: 'Corso',
            flex: 1,
            minWidth: 200,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
    ];

    const handleEditClick = (params) => {
        setSelectedCategoria(params.row);
        setEditForm({
            nome: params.row.nome,
            tipo: params.row.tipo,
            codice: params.row.codice,
        });
        setEditModalOpen(true);
    };

    const handleEditClose = () => {
        setEditModalOpen(false);
        setSelectedCategoria(null);
        setEditForm({
            nome: '',
            tipo: '',
            codice: '',
        });
    };

    const handleEditChange = (e) => {
        setEditForm({
            ...editForm,
            [e.target.name]: e.target.value,
        });
    };

    const handleEditSave = async () => {
        try {
            const response = await unsplash.put(
                'categorieCorsi',
                {
                    categoria: {
                        ...editForm,
                        id: selectedCategoria.id,
                    },
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                }
            );

            if (response.data.message === 'Categoria updated successfully') {
                setSnack({
                    severity: 'success',
                    messaggio: 'Categoria aggiornata con successo',
                    open: true,
                });
                setOpenSnack(true);
                handleEditClose();
                // Refresh the data
                fetchData();
            }
        } catch (error) {
            console.error(error);
            setSnack({
                severity: 'error',
                messaggio: "Errore durante l'aggiornamento della categoria",
                open: true,
            });
            setOpenSnack(true);
        }
    };

    const actionColumn = {
        field: 'actions',
        headerName: 'Azioni',
        width: 80,
        headerAlign: 'center',
        align: 'center',
        sortable: false,
        renderCell: (params) => (
            <IconButton
                onClick={() => handleEditClick(params)}
                color="primary"
                size="small"
            >
                <Edit />
            </IconButton>
        ),
    };

    const columns = clientId
        ? [actionColumn, ...baseColumns]
        : [actionColumn, ...baseColumns, ...clientColumns];

    return (
        <>
            <GlobalSnackbar
                severity={snack.severity}
                messaggio={snack.messaggio}
                openSnack={openSnack}
                handleCloseSnack={handleCloseSnack}
            />
            <Grid item xs={12}>
                <Card sx={{ position: 'relative', my: 'auto' }}>
                    <CardHeader
                        sx={{ textAlign: 'center' }}
                        title={'Categorie Corsi'}
                        titleTypographyProps={{ variant: 'h4' }}
                    />
                </Card>

                <Card sx={{ marginTop: '10px' }}>
                    <CardContent sx={{ p: 0 }}>
                        <DettaglioCategoria
                            Title="Crea Categoria"
                            Operation="Nuovo"
                            snack={snack}
                            openSnack={openSnack}
                            handleCloseSnack={handleCloseSnack}
                            setSnack={setSnack}
                            setOpenSnack={setOpenSnack}
                            clientId={clientId}
                            onSuccess={fetchData}
                        />
                        <Box sx={{ width: '100%' }}>
                            <CustomTabPanel value={value} index={0}>
                                <Box sx={{ height: '60vh', width: '100%' }}>
                                    <DataGridPro
                                        components={{
                                            Toolbar: CustomToolbar,
                                            Footer: CustomFooterPersonalized,
                                        }}
                                        slots={{
                                            loadingOverlay: LinearProgress,
                                        }}
                                        disableSelection={true}
                                        localeText={
                                            itIT.components.MuiDataGrid
                                                .defaultProps.localeText
                                        }
                                        rows={categorie}
                                        getRowId={(row) =>
                                            `${row.id}-${row.corso}`
                                        }
                                        columns={columns}
                                    />
                                </Box>
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={1}>
                                <Box
                                    sx={{ height: '60vh', width: '100%' }}
                                ></Box>
                            </CustomTabPanel>
                        </Box>
                    </CardContent>
                </Card>
            </Grid>

            {/* Edit Modal */}
            <Dialog
                open={editModalOpen}
                onClose={handleEditClose}
                TransitionComponent={Transition}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Modifica Categoria</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Nome"
                                name="nome"
                                value={editForm.nome}
                                onChange={handleEditChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Tipo"
                                name="tipo"
                                value={editForm.tipo}
                                onChange={handleEditChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Codice"
                                name="codice"
                                value={editForm.codice}
                                onChange={handleEditChange}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleEditClose}>Annulla</Button>
                    <Button
                        onClick={handleEditSave}
                        variant="contained"
                        color="primary"
                    >
                        Salva
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default CategorieCorsi;
